import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Module from 'react-dom/client';
import "./Styles/Core.Module.css";
import '@flaticon/flaticon-uicons/css/all/all.css';
import Splash from './Code/Splash';

Module.createRoot(
	document.getElementsByTagName('react-render')[0]
).render(
  	<React.StrictMode>
		<Router>
			<Splash />
		</Router>
	</React.StrictMode>
);